import React from "react";

const WaterModal = ({ waterData }) => {
  const showWaterItemData = (value, ind) => {
    if (value.type === "heading") {
      return (
        <div key={ind} className="water-modal-head">
          <div>{value?.content}</div>
        </div>
      );
    } else if (value.type === "para") {
      return (
        <div key={ind} className="water-modal-content-wrapper">
          {value?.content.length > 0 &&
            value?.content.map((val, i) => (
              <p className="water-modal-para" key={i}>
                {val}
              </p>
            ))}
        </div>
      );
    } else if (value.type === "list") {
      return (
        <div key={ind} className="water-modal-list-wrapper">
          <div className="water-modal-list-head">{value?.dataHeader}</div>
          <ul className="water-modal-list">
            {value?.content.map((val, i) => (
              <li key={i}>{val}</li>
            ))}
          </ul>
        </div>
      );
    } else if (value.type === "link") {
      return (
        <div key={ind} className="water-modal-links-wrapper">
          <div className="water-modal-link-head">{value?.dataHeader}</div>
          <div className="water-modal-links">
            {value?.content.length > 0 &&
              value?.content.map((val, i) => (
                <a
                  key={i}
                  href={val.body}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {val.head}
                </a>
              ))}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const showWaterData = (item) => {
    if (item?.data.length > 0) {
      return item?.data.map((value, ind) => {
        return showWaterItemData(value, ind);
      });
    }
  };

  return (
    <div
      className="modal fade water-modal"
      id="waterModal"
      tabIndex="-1"
      aria-labelledby="waterModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body" tabIndex="0">
            <h5 className="modal-heading" id="waterModalLabel">
              IMPORTANCE OF WATER
            </h5>
            {waterData.length > 0 &&
              waterData.map((item, i) => (
                <div className="water-item-wrapper" key={i}>
                  {showWaterData(item)}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaterModal;
